export default __webpack_public_path__ + "static/media/copy.697f8dd0.svg";